import React, { useState, useEffect } from "react";
import "../styles/Events.css";

const Events = () => {
  const [filter, setFilter] = useState("upcoming");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null); // Estado para el diálogo
  const [showCalendar, setShowCalendar] = useState(false); // Estado para el modal del calendario
  const [events, setEvents] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState("");

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const res = await fetch("https://alaiak.eus/api/alaiak/events");
      if (!res.ok) throw new Error("Error al cargar eventos");
      const data = await res.json();
      setEvents(data);
    } catch (err) {
      // Manejo de error opcional
    }
  };

  const filteredEvents = events.filter((event) => {
    const eventDate = new Date(event.date_start || event.date);
    const today = new Date();
    return filter === "upcoming" ? eventDate >= today : eventDate < today;
  });

  const changeMonth = (direction) => {
    const newDate = new Date(currentDate);
    newDate.setMonth(currentDate.getMonth() + direction);
    setCurrentDate(newDate);
  };

  const openEventDialog = (event) => {
    setSelectedEvent(event);
  };

  const closeEventDialog = () => {
    setSelectedEvent(null);
  };

  const navigateToAgenda = () => {
    const agendaSection = document.querySelector(".events-list");
    if (agendaSection) {
      agendaSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const renderCalendar = () => {
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
    );
    const daysInMonth = lastDayOfMonth.getDate();

    const days = [];
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        i,
      );
      const event = events.find(
        (event) =>
          new Date(event.date_start || event.date).toDateString() ===
          date.toDateString(),
      );
      days.push(
        <li
          key={i}
          className={`calendar-event ${event ? "has-event" : ""}`}
          onClick={() => event && openEventDialog(event)}
        >
          <span className="calendar-date">{i}</span>
          {event && <span className="calendar-dot"></span>}
        </li>,
      );
    }

    const monthNamesInBasque = [
      "urtarrila",
      "otsaila",
      "martxoa",
      "apirila",
      "maiatza",
      "ekaina",
      "uztaila",
      "abuztua",
      "iraila",
      "urria",
      "azaroa",
      "abendua",
    ];

    return (
      <div className="calendar">
        <div className="calendar-header">
          <button onClick={() => changeMonth(-1)}>Aurrekoa</button>
          <h3>
            {`${currentDate.getFullYear()}-ko ${monthNamesInBasque[currentDate.getMonth()]}`}
          </h3>
          <button onClick={() => changeMonth(1)}>Hurrengoa</button>
        </div>
        <ul>{days}</ul>
        <p className="calendar-legend">Egun markatuak: ekitaldiak</p>
      </div>
    );
  };

  const renderEventDialog = () => {
    if (!selectedEvent) return null;

    return (
      <div className="event-dialog" onClick={closeEventDialog}>
        <div
          className="event-dialog-card"
          onClick={(e) => e.stopPropagation()} // Evitar cerrar el modal al hacer clic dentro
        >
          <p className="event-dialog-date">{selectedEvent.date}</p>
          <h3 className="event-dialog-title">{selectedEvent.title}</h3>
          <p className="event-dialog-location">📍 {selectedEvent.location}</p>
          <div className="event-dialog-actions">
            <button
              className="event-dialog-link"
              onClick={() => {
                closeEventDialog();
                navigateToAgenda();
              }}
            >
              Ver agenda completa
            </button>
            <button className="event-dialog-close" onClick={closeEventDialog}>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    );
  };

  const toggleCalendarModal = () => {
    setShowCalendar(!showCalendar);
  };

  // const renderCalendarModal = () => {
  //   if (!showCalendar) return null;
  //   return (
  //     <div className="calendar-modal" onClick={toggleCalendarModal}>
  //       <div
  //         className="calendar-modal-content"
  //         onClick={(e) => e.stopPropagation()} // Evitar cerrar el modal al hacer clic dentro
  //       >
  //         {renderCalendar()}
  //         <button
  //           className="calendar-modal-close"
  //           onClick={toggleCalendarModal}
  //         >
  //           Cerrar
  //         </button>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className="events-page">
      {/* Cabecera */}
      <header className="events-header">
        <h1>Ekitaldiak</h1>
        <p>Kontzertuak, jaiak eta kultura ekitaldiak</p>
      </header>

      {/* Filtros */}
      <div className="events-filters">
        <button
          className={filter === "upcoming" ? "active" : ""}
          onClick={() => setFilter("upcoming")}
        >
          Hurrengoak
        </button>
        <button
          className={filter === "past" ? "active" : ""}
          onClick={() => setFilter("past")}
        >
          Iraganekoak
        </button>
      </div>

      <div className="events-content">
        {/* Lista de eventos */}
        <ul className="events-list">
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event, index) => (
              <li
                key={event.id}
                className={`event-item ${
                  index === 0 && filter === "upcoming" ? "highlight" : ""
                }`}
                data-date={event.date}
              >
                <span className="event-date">{event.date}</span>
                <h3>{event.title}</h3>
                <p>📍 {event.location}</p>
                <p>{event.description}</p>
              </li>
            ))
          ) : (
            <p className="no-events-message">
              {filter === "upcoming"
                ? "Une honetan ez dugu ekitaldirik programatuta, baina gure sare sozialetan iragartzen ditugu berriak."
                : "Ez dago iraganeko ekitaldirik."}
            </p>
          )}
        </ul>
        {/* Diálogo contextual */}
        {renderEventDialog()}
        {/* Calendario para escritorio */}
        {renderCalendar()} {/* Mantener el calendario para escritorio */}
      </div>

      {/* Cierre de página */}
      <footer className="events-footer">
        <p>
          Eskerrik asko gure agenda bisitatzeagatik. Informazio gehiago nahi
          baduzu, jarraitu gaitzazu sare sozialetan edo idatzi gurekin
          harremanetan jartzeko.
        </p>
      </footer>
    </div>
  );
};

export default Events;
